var _defs, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 12,
    viewBox: "0 0 44 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n.dot { transform-origin: 50% 50%; -webkit-transform-origin: 50% 50%;\r\n\t-webkit-animation: bouncedelay 1s infinite ease-in-out both; \r\n\tanimation: bouncedelay 1s infinite ease-in-out both; }\r\n.dot-1 { -webkit-animation-delay: -.54s; animation-delay: -.54s}\r\n.dot-2 { -webkit-animation-delay: -.48s; animation-delay: -.48s}\r\n.dot-3 { -webkit-animation-delay: -.32s; animation-delay: -.32s}\r\n@-webkit-keyframes bouncedelay {\r\n\t0%,80%,100%{ -webkit-transform: scale(0.8); }\t40%{ -webkit-transform: scale(1); } }\r\n@keyframes bouncedelay {\r\n\t0%,80%,100%{ transform: scale(0.8); }\t40%{ transform: scale(1); } }\r\n\t\t"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "dot dot-1",
    cx: 6,
    cy: 6,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "dot dot-2",
    cx: 22,
    cy: 6,
    r: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "dot dot-3",
    cx: 38,
    cy: 6,
    r: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLoading);
export default __webpack_public_path__ + "static/media/m_loading.f3217607aa20a11b26f5420ca3c2a21f.svg";
export { ForwardRef as ReactComponent };